<template>
    <v-app>
        <!-- Landing page inside phone (screenshotlayer) -->
        <preview-phone v-if="screenshot">
            <landing-page class="screenshot-size" />
        </preview-phone>

        <landing-page v-else />
    </v-app>
</template>

<script>
import LandingPage from "./components/LandingPage";
import PreviewPhone from "./components/PreviewPhone";

export default {
    name: "App",
    components: {
        LandingPage,
        PreviewPhone,
    },
    data() {
        return {
            screenshot: false,
        };
    },
    created() {
        // Check if phone preview (apiscreenshotlayer)
        const urlParams = new URLSearchParams(window.location.search);
        const screenshot = urlParams.get("screenshot");

        if (screenshot) this.screenshot = true;
    },
};
</script>

<style>
#app {
    position: relative;
}

.screenshot-size {
    height: 100%;
}
</style>
